import { StyleSheet } from 'react-native';

import constants from '../../Config/constants';
import themeColor from '../../Theme/colors';
import themeStyle from '../../Theme/styles';

export default StyleSheet.create({
  webBox: constants.isWeb
    ? {
        ...themeStyle.pageVerticalSpacing,
        ...themeStyle.pageHorizontalSpacing,
        borderWidth: 1,
        borderColor: themeColor.gray,
        borderRadius: 5,
      }
    : {},
});
